// =============================================================================
// Analytics
// =============================================================================



$('document').ready(() => {

    const ctaClickEvent = type => {
        return event => {

            var link = $(event.target).attr('href');
            if (link.indexOf("contact-us")) {

                gtag('event', 'Contact Us', {
                  'event_category': 'CTA Button Click',
                  'event_label': $(event.target).html(),
                });

            } else if (link.indexOf("brochure")) {

                gtag('event', 'Request Brochure', {
                  'event_category': 'CTA Button Click',
                  'event_label': $(event.target).html(),
                });

            } else {

                gtag('event', 'Other', {
                  'event_category': 'CTA Button Click',
                  'event_label': $(event.target).html(),
                });

            }
        };
    };

    $('.button-cta').on('click', ctaClickEvent());


    document.addEventListener( 'wpcf7invalid', function( event ) { formEvent(event, 'Validation Fail') }, false );
    document.addEventListener( 'wpcf7spam', function( event ) { formEvent( event, 'Spam Submission' ) }, false );
    document.addEventListener( 'wpcf7mailsent', function( event ) { formEvent( event, 'Mail Sent' ) }, false );
    document.addEventListener( 'wpcf7mailfailed', function( event ) { formEvent( event, 'Mail Failed' ) }, false );

    function formEvent(event, type) {

        var inputs = event.detail.inputs, event_category;
     
        for ( var i = 0; i < inputs.length; i++ ) {
            if ( 'form-name' == inputs[i].name ) {
                event_category = inputs[i].value + ' ' + type;
                break;
            }
        }

        var referrer = document.referrer;

        inputs = inputs.filter(function(obj) { return obj.name !== 'g-recaptcha-response';})

        var label = '{"referrer":"'+referrer+'","inputs":"' + JSON.stringify(inputs) + '"';

        gtag('event', event_category, {
          'event_category': 'Form Submission',
          'event_label': label,
        });

        // console.log( label );

    }

    var ppc = 0,
        pc25fired = false,
        pc50fired = false,
        pc75fired = false,
        pc90fired = false,
        formSubmitted = false;

    document.addEventListener( 'wpcf7mailsent', function( e ) { formSubmitted = true; });

    document.addEventListener('scroll', function(){
     
        var h =  document.documentElement,
            b =  document.body,
            st =  'scrollTop',
            sh =  'scrollHeight';
     
        var percent = parseInt ( (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100);

        if (percent > ppc) {
     
            // console.log(percent + "% v " + ppc + '%');
            if (percent >= 25 && ppc < 25 && ! pc25fired)
            {
                gtag('event', 'moreThan25%', {
                  'event_category': 'Scrolling',
                  'event_label': document.title,
                });
                pc25fired = true;
                // console.log('Fired 25%');
            }
            else if (percent >= 50 && ppc < 50 && ! pc50fired)
            {
                gtag('event', 'moreThan50%', {
                  'event_category': 'Scrolling',
                  'event_label': document.title,
                });
                pc50fired = true;
                // console.log('Fired 50%');
            }
            else if (percent >= 75 && ppc < 75 && ! pc75fired)
            {
                gtag('event', 'moreThan75%', {
                  'event_category': 'Scrolling',
                  'event_label': document.title,
                });
                pc75fired = true;
                // console.log('Fired 75%');
            }
            else if (percent >= 90 && ppc < 90 && ! pc90fired)
            {
                gtag('event', 'moreThan90%', {
                  'event_category': 'Scrolling',
                  'event_label': document.title,
                });
                pc90fired = true;
                // console.log('Fired 90%');
            }
        }

        ppc = percent;
   
    });

    var formSelector = 'form'; // Modify this CSS selector to match your form. Default is first form on the page.
    var attribute = 'name';
    var history = [];
    window.addEventListener('beforeunload', function() {
      if (history.length && ! formSubmitted) {
        gtag('event', 'Contact Form', {
          'event_category': 'Form Abandonment',
          'event_label': history.join(' > ')
        });
        gtag('event', 'Contact Form', 'Form Abandonment', history.join(' > '));
      }
    });
  
    document.querySelector(formSelector).addEventListener('change', function(e) {
      history.push(e['target'].getAttribute(attribute));
      // console.log(history);
    });
 
});


// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/Analytics.js